export const CHANGED_PAGE = 'change-page';

const NEXT = 'Next';
const PREV = 'Previous';
const SPACE = '…';
const PAGE_BUFFER = 2; //How many pages on either side of the current page to display

const $ = jQuery;
let el = null;
let pageTotal = 1;
let currentPage = 1;

function onDocumentReady() {
	el = $('#content-exchange-pagination');
	if (el.length > 0) {
		initialize();
	}
}

function initialize() {
	el.on('click', '.pagination-item', onClickPaginationItem);
}

function scrollToTop() {
	$('html, body').animate({ scrollTop: 0 });
}

function onClickPaginationItem(e) {
	let clicked = $(e.currentTarget);
	let destination = clicked.text();

	switch (destination) {
		case NEXT:
			goToNextPage();
			break;

		case PREV:
			goToPrevPage();
			break;

		default:
			goToPage(destination);
	}

	scrollToTop();
}

function render() {
	el.html('');
	el.append(getPaginationButton(PREV, PREV.toLocaleLowerCase()));

	for (let i = 1; i <= pageTotal; i++) {
		if (isEligbileForDisplay(i)) {
			el.append(getPaginationButton(i));
		} else {
			el.append(getPaginationButton(SPACE));
		}
	}

	el.append(getPaginationButton(NEXT, NEXT.toLocaleLowerCase()));
}

function isEligbileForDisplay(i) {
	let distanceFromCurrentPage = Math.abs(currentPage - i);

	return i === 1 || i === pageTotal || distanceFromCurrentPage <= PAGE_BUFFER;
}

function getPaginationButton(n, extraClass) {
	let ret = document.createElement('button');

	ret.className = 'pagination-item';

	if (n === SPACE) {
		ret.className += ' space';
	}

	if (String(currentPage) === String(n)) {
		ret.className += ' active';
	}

	if (extraClass) {
		ret.className += ` ${extraClass}`;
	}

	ret.innerHTML = n;

	return ret;
}

export function goToPage(n) {
	currentPage = parseInt(n, 10);
	el.trigger(CHANGED_PAGE, n);
	render();
}

function goToNextPage() {
	let n = currentPage + 1;
	while (n > pageTotal) {
		n -= pageTotal;
	}

	goToPage(n);
}

function goToPrevPage() {
	let n = currentPage - 1;
	while (n <= 0) {
		n += pageTotal;
	}

	goToPage(n);
}

export function setPageTotal(n) {
	pageTotal = n;
	render();
}

export function getPageState() {
	return { pageTotal, currentPage };
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
